export class Importer {
  import(format, payload) {
    if (format === "json") {
      return typeof payload === "string" ? JSON.parse(payload) : payload;
    }

    throw new Error(`Unsupported import format: ${format}`);
  }
}
